import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import axios from 'axios';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { DateCell } from '../../../../utils/Cells';

class EmployeeHistory extends Component {
    state = {
        employeeHistory: []
    }

    componentDidMount() {
        console.log(this.props.row);
        this.callApi(this.props.row.employee.privateId)
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    enrich = (data) => {
        // data.map((item) => {
        // item.dateDate = (item.date) ? f.format(new Date(item.date)) : "";
        //     return item;
        // })
        console.log(data);
        this.setState({ employeeHistory: data.employeeHistory })
    }

    callApi = async (id) => {
        const path = `/api/employeehistory/${id}`;
        const response = await axios.get(path);
        if (response.status !== 200) throw Error(response.message);
        return response;
    };

    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Kezdő dátum</TableCell>
                            <TableCell>Vég dátum</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.employeeHistory.map(s => {
                            return <TableRow key={s.privateId}>
                                <TableCell><DateCell value={s.startDate} /></TableCell>
                                <TableCell><DateCell value={s.endDate} /></TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}

export default withSnackbar(EmployeeHistory);
